module.exports = __webpack_public_path__ + "static/media/admin.980fdd96.png";